import api from './api';

// Rental Properties API Client
export const rentalAPI = {
  // Properties
  listProperties: (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.client_id) queryParams.append('client_id', params.client_id);
    if (params.status) queryParams.append('status_filter', params.status);
    return api.get(`/api/rental-properties?${queryParams.toString()}`);
  },
  createProperty: (data) => api.post('/api/rental-properties', data),
  getProperty: (id) => api.get(`/api/rental-properties/${id}`),
  updateProperty: (id, data) => api.patch(`/api/rental-properties/${id}`, data),
  
  // Income
  createIncome: (propertyId, data) => api.post(`/api/rental-properties/${propertyId}/income`, data),
  
  // Expenses
  createExpenses: (propertyId, data) => api.post(`/api/rental-properties/${propertyId}/expenses`, data),
  
  // Schedule
  generateSchedule: (propertyId, financialYear) => 
    api.get(`/api/rental-properties/${propertyId}/schedule?financial_year=${financialYear}`)
};